'use client';

import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import NextLink from 'next/link';
export const NextLinkBehaviour = forwardRef<HTMLAnchorElement, {
  href: string;
}>(function LinkBehaviour(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <NextLink ref={ref} prefetch={false} {...props} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});